<template>
    <main class="SectionSubscribe-MAIN">
        <img src="../assets/arrow-back.png" @click="$router.push('/');"/>
        <h1>Newsletter</h1>
        <hr>
        <p>
            Recibe notificaciones sobre próximas exposiciones, perfiles de artistas, eventos. Freccuencia de envío controlada.
            <br/>Puede cancelar su suscripción en cualquier momento.
        </p>

        <b>Correo:</b>
        <input type="email" placeholder="correo@dominio.com" v-model="email"/>
        <b>Nombre:</b>
        <input type="text" placeholder="Nombre o alias" v-model="name"/>

        <label>
            <input type="checkbox" v-model="acceptedPolicy"/>
            Comprendo y acepto la&nbsp;<span @click="goToPrivacy()">Política Privacidad.</span>
        </label>
        <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>
        <p v-if="okLog" class="ok-log">{{ okLog }}</p>

        <button @click="subscribe()" :disabled="loading || !acceptedPolicy">SUSCRIBIRSE</button>
    </main>
</template>

<script>
export default {
    name: 'SectionSubscribe',
    data(){
        return{
            email: '',
            name: '',
            acceptedPolicy: false,
            loading: false,
            errorMsg: '',
            okLog: '',
        }
    },
    methods: {
        goToPrivacy(){
            this.$router.push({ name: 'privacy' });
        },

        async subscribe(){
            this.errorMsg = '';
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/newsletter_subscribe.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        email: this.email,
                        name: this.name,
                        accepted_policy: this.acceptedPolicy
                    })
                });
                const result = await response.json();

                console.log(result.message);
                this.errorMsg = result.message;

                if(result.status === 'success') {
                    this.email = '';
                    this.name = '';
                    this.acceptedPolicy = false;
                    this.errorMsg = '';
                    this.okLog = result.message;
                }
            } catch(error) {
                console.error(error);
            }
        },
    }
}
</script>

<style scoped lang="stylus">
.SectionSubscribe-MAIN
    display: flex
    flex-direction: column
    padding: 10px
    width: calc(100% - 20px)
    min-height: calc(100vh - 20px)
    background-color: white

    >img
        width: 8vw
        margin-bottom: 2vw

    >h1
        font-family: "Archivo ExtraCondensed", sans-serif
        text-transform: uppercase
        font-size: 12vw
        text-wrap: balance
        margin-bottom: 0

    >hr
        width: 100%
        border: 1px solid black

    >p
        font-family: "Archivo ExtraCondensed", sans-serif
        margin-top: 0
        font-size: 6vw
        color: #B0B0B0
        margin-bottom: 8vh

        >span
            color: black
            text-decoration: underline

     >button
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: rgb(1, 90, 255)
        color: white
        max-width: 75vw
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 6vw
        border-radius: 100vw
        z-index: 1
        font-family: "DM Mono", monospace
        border: none

    /* inputs */
    >b
        font-family: "Archivo ExtraCondensed", sans-serif
        font-size: 6.5vw
        text-transform: uppercase
        color: black

    >input
        font-family: "Archivo ExtraCondensed", sans-serif
        padding: 2vw 0
        margin-bottom: 4vh
        border: none
        border-bottom: 1px solid black
        font-size: 5vw

        &::placeholder
            color: #C3C3C3
            font-size: 6vw

    >label
        display: flex
        align-items: center
        font-family: "Archivo ExtraCondensed", sans-serif
        color: #B0B0B0
        font-size: 5vw

        >input
            margin-right: 10px
        
        >span
            color: black
            text-decoration: underline

    /* error msg */
    .error-msg
    .ok-log
        color: rgb(1, 90, 255)
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 100
        font-size: 4.4vw
        margin-bottom: 0
        margin-top: 25px !important
        color: red !important  

    .ok-log
        color: #015aff !important
</style>